import React, { useState, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { Calendar, Collapse, ConfigProvider } from 'antd';
import styles from './miniCalendar.module.scss';
import stylesOuter from './eventsgroups.module.scss';
import { ScheduleActions, useActions, useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import chLocale from 'antd/es/locale/zh_CN';
import enLocale from 'antd/es/locale/en_US';
import { api } from 'api';
export const MINICALENDAR_FORMAT_STR = 'YYYY-MM-DD';
const storeApi = api.getDataStoreApi();
export const isToday = time => {
    const now = moment();
    const timeDayjs = moment(time);
    return timeDayjs.format(MINICALENDAR_FORMAT_STR) === now.format(MINICALENDAR_FORMAT_STR);
};
const { Panel } = Collapse;
const MiniCalendar = () => {
    const { miniSelectedDay: selectedDay, scheduledDate, weekFirstDay, weekNumbersVisible, activeStartDate, activeEndDate, } = useAppSelector(state => state.scheduleReducer);
    const scheduleActions = useActions(ScheduleActions);
    const [language] = useState(() => {
        const result = storeApi.getSync('system_language');
        if (result.suc && result.data) {
            return result.data;
        }
        return 'zh';
    });
    const weekNumbers = useMemo(() => {
        const res = [];
        const momentDate = moment(activeStartDate);
        for (let i = 0; i < 6; i++) {
            res[i] = momentDate.week();
            momentDate.add(1, 'week');
        }
        return res;
    }, [activeStartDate]);
    const isSelectedDay = time => selectedDay.isSame(time);
    const isMonth = time => selectedDay.month() === time.month();
    const hasSchedule = (m) => scheduledDate.includes(m.format(MINICALENDAR_FORMAT_STR));
    const onSelectedDayChange = (m) => {
        scheduleActions.setMiniSelectedDay(m);
    };
    const dateFullCellRender = value => {
        const date = value.date();
        const hasScheduleTemp = hasSchedule(value);
        return (React.createElement("div", { className: classnames(styles.miniDay, {
                [styles.today]: isToday(value) && !isSelectedDay(value),
                [styles.todaySelected]: isToday(value) && isSelectedDay(value),
                [styles.notTodaySelected]: !isToday(value) && isSelectedDay(value),
                [styles.notMonth]: !isMonth(value),
            }) },
            React.createElement("span", { style: { marginTop: hasScheduleTemp ? -2 : 0 } }, date),
            hasScheduleTemp && React.createElement("div", { className: styles.minidot }, " ")));
    };
    useEffect(() => {
        moment.updateLocale('en', {
            weekdaysMin: getIn18Text('RI_YI_ER').split('_'),
            week: {
                dow: weekFirstDay,
            },
        });
        moment.updateLocale('zh-cn', {
            weekdaysMin: getIn18Text('RI_YI_ER').split('_'),
            week: {
                dow: weekFirstDay,
            },
        });
        onSelectedDayChange(selectedDay.clone().add(1, 'minute'));
    }, [weekFirstDay]);
    const prevMonth = e => {
        const prev = selectedDay.clone().subtract(1, 'M').date(1).format(MINICALENDAR_FORMAT_STR);
        onSelectedDayChange(moment(prev));
        e.stopPropagation();
    };
    const nextMonth = e => {
        const next = selectedDay.clone().add(1, 'M').date(1).format(MINICALENDAR_FORMAT_STR);
        onSelectedDayChange(moment(next));
        e.stopPropagation();
    };
    const headerRender = () => (React.createElement("div", { className: `${styles.miniHeader} miniCalendar-miniHeader` },
        React.createElement("span", { className: styles.miniMonth }, selectedDay.format(getIn18Text('YYYYNIANMMYUE'))),
        React.createElement("i", { className: classnames(styles.arrow, 'arrow', styles.left, 'left'), onClick: e => {
                prevMonth(e);
            } }),
        React.createElement("i", { className: classnames(styles.arrow, 'arrow', styles.right, 'right'), onClick: e => {
                nextMonth(e);
            } })));
    const onChange = date => {
        onSelectedDayChange(date);
    };
    return (React.createElement(Collapse, { className: stylesOuter.collapse, ghost: true, expandIconPosition: "right", defaultActiveKey: ['0'], expandIcon: panelProps => (React.createElement("span", { className: `dark-invert ${stylesOuter.expandArrow}` },
            React.createElement("i", { className: classnames([stylesOuter.expandIcon], {
                    [stylesOuter.expandIconCollapse]: !panelProps.isActive,
                }) }))) },
        React.createElement(Panel, { header: headerRender(), key: "0" },
            React.createElement("div", { className: styles.miniCalendar },
                React.createElement(ConfigProvider, { locale: language === 'zh' ? chLocale : enLocale },
                    React.createElement("div", { className: styles.weekNumberWrap, hidden: !weekNumbersVisible }, weekNumbers.map(weekNumber => {
                        return React.createElement("p", null, weekNumber);
                    })),
                    React.createElement(Calendar, { onPanelChange: (...args) => {
                            console.log('onPanelChange', args);
                        }, fullscreen: false, headerRender: () => null, value: selectedDay, dateFullCellRender: dateFullCellRender, onChange: onChange }))))));
};
export default MiniCalendar;
